import React from "react";
import { Card, Steps, Button, Typography, Alert, Row, Col, Space } from "antd";
import { MailOutlined, CheckCircleOutlined, UserOutlined, LockOutlined } from "@ant-design/icons";
import "./EmailVerification.scss";

const { Title, Paragraph } = Typography;
const { Step } = Steps;

interface EmailVerificationProps {
  email: string;
  onReturnToLogin?: () => void;
}

const EmailVerification: React.FC<EmailVerificationProps> = ({ email, onReturnToLogin }) => {
  return (
    <Card className="email-verification-card">
      <Row justify="center">
        <Col xs={24} md={20}>
          <Space direction="vertical" size="large" style={{ width: "100%" }}>
            <Title level={3}>Verify Your Email Address</Title>

            <Alert
              message="Email Verification Required"
              description="Please check your inbox and click the verification link to continue."
              type="warning"
              showIcon
            />

            <Paragraph>
              We&apos;ve sent a verification email to <strong>{email}</strong>. Please check your inbox (and spam
              folder) and click the verification link to complete your registration.
            </Paragraph>

            <Steps current={1} direction="horizontal">
              <Step title="Sign Up" icon={<UserOutlined />} description="Create account" />
              <Step title="Verify Email" icon={<MailOutlined />} description="Check your inbox" status="process" />
              <Step title="Complete" icon={<CheckCircleOutlined />} description="Access your account" />
            </Steps>

            <div className="verification-instructions">
              <Title level={4}>What to do next:</Title>
              <ol>
                <li>Open the email from Sensorflow</li>
                <li>Click the verification link in the email</li>
                <li>Once verified, return to this page and click &quot;Return to Login&quot;</li>
              </ol>
            </div>

            <Row gutter={16} justify="center">
              <Col>
                <Button type="primary" icon={<LockOutlined />} onClick={onReturnToLogin}>
                  Return to Login
                </Button>
              </Col>
            </Row>
          </Space>
        </Col>
      </Row>
    </Card>
  );
};

export default EmailVerification;
